import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import useAddressSearch from "./useAddressSearch";

export default function AddressSearch({ onAddressSelect }) {
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const { getPlacePredictions, getPlaceDetails } = useAddressSearch();

  const onPredictionCallback = (predictions) => {
    console.log(predictions)
    setSuggestions(predictions);
  };

  const handleInputChange = (value) => {
    setSuggestions([]);
    setInputValue(value);
    getPlacePredictions(value, onPredictionCallback);
  };

  const handleAddressSelect = (value, onAddressSelect) => {
    if (value) {
      getPlaceDetails(value.id, onAddressSelect);
    }
  };

  return (
    <>
      <div id="place-container"></div>
      <Autocomplete
        freeSolo
        options={suggestions}
        inputValue={inputValue}
        onInputChange={(event, value) => handleInputChange(value)}
        onChange={(event, value) => handleAddressSelect(value, onAddressSelect)}
        filterOptions={(options) => options.slice(0, 10)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Address"
            variant="outlined"
            fullWidth
            margin="dense"
            size="small"
          />
        )}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.id === value.id}
      />
    </>
  );
}
